import React, { useState } from 'react';
import { X } from 'lucide-react';

const AddGradeModal = ({ classId, enrollments, settings, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    studentId: '',
    gradeCategory: '',
    assignmentName: '',
    pointsEarned: '',
    pointsPossible: '100',
    feedback: '',
    status: 'graded'
  });

  const categories = settings?.gradeCategories || [
    { name: 'Participation', weight: 10 },
    { name: 'Homework', weight: 30 },
    { name: 'Quizzes', weight: 20 },
    { name: 'Tests', weight: 40 }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...formData,
      pointsEarned: parseFloat(formData.pointsEarned),
      pointsPossible: parseFloat(formData.pointsPossible)
    });
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-900">Add Grade</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Student Selection */}
          <div>
            <label className="form-label">Student *</label>
            <select
              value={formData.studentId}
              onChange={(e) => setFormData({...formData, studentId: e.target.value})}
              className="form-input"
              required
            >
              <option value="">Select student...</option>
              {enrollments.map(enrollment => (
                <option key={enrollment.student.id} value={enrollment.student.id}>
                  {enrollment.student.firstName} {enrollment.student.lastName}
                </option>
              ))}
            </select>
          </div>

          {/* Category */}
          <div>
            <label className="form-label">Category *</label>
            <select
              value={formData.gradeCategory}
              onChange={(e) => setFormData({...formData, gradeCategory: e.target.value})}
              className="form-input"
              required
            >
              <option value="">Select category...</option>
              {categories.map(cat => (
                <option key={cat.name} value={cat.name}>
                  {cat.name} ({cat.weight}%)
                </option>
              ))}
            </select>
          </div>

          {/* Assignment Name */}
          <div>
            <label className="form-label">Assignment Name</label>
            <input
              type="text"
              value={formData.assignmentName}
              onChange={(e) => setFormData({...formData, assignmentName: e.target.value})}
              className="form-input"
              placeholder="e.g., Chapter 5 Quiz"
            />
          </div>

          {/* Points */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="form-label">Points Earned *</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={formData.pointsEarned}
                onChange={(e) => setFormData({...formData, pointsEarned: e.target.value})}
                className="form-input"
                required
              />
            </div>
            <div>
              <label className="form-label">Points Possible *</label>
              <input
                type="number"
                step="0.01"
                min="0.01"
                value={formData.pointsPossible}
                onChange={(e) => setFormData({...formData, pointsPossible: e.target.value})}
                className="form-input"
                required
              />
            </div>
          </div>

          {/* Status */}
          <div>
            <label className="form-label">Status</label>
            <select
              value={formData.status}
              onChange={(e) => setFormData({...formData, status: e.target.value})}
              className="form-input"
            >
              <option value="graded">Graded</option>
              <option value="missing">Missing</option>
              <option value="excused">Excused</option>
              <option value="incomplete">Incomplete</option>
              <option value="pending_review">Pending Review</option>
            </select>
          </div>

          {/* Feedback */}
          <div>
            <label className="form-label">Feedback (visible to parents)</label>
            <textarea
              value={formData.feedback}
              onChange={(e) => setFormData({...formData, feedback: e.target.value})}
              className="form-input"
              rows={3}
              placeholder="Optional feedback for student/parent..."
            />
          </div>

          {/* Actions */}
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
            >
              Add Grade
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGradeModal;
